"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_validator_1 = require("class-validator");
const enums_1 = require("../enums");
const GetModelContractQuery_1 = tslib_1.__importDefault(require("./GetModelContractQuery"));
const class_transformer_1 = require("class-transformer");
class GetModelContractQueryV2 extends GetModelContractQuery_1.default {
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsBoolean)(),
    (0, base_models_1.ConvertToBoolean)(),
    (0, base_models_1.Docs)({
        example: 'true',
        description: `If true then in the response you will see the cost rate of return electricity back to the grid.
When calling AOM we only fill in the consumptionReturnPeak. The consumption return off peak, so the off hours, have no influence on the rate
as far as we can see. Atleast not for the model contract.`,
    }),
    (0, class_transformer_1.Expose)({ name: 'return_supply' }),
    tslib_1.__metadata("design:type", Boolean)
], GetModelContractQueryV2.prototype, "returnSupply", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsIn)(Object.values(enums_1.ModelContractRate)),
    (0, base_models_1.Docs)({
        example: enums_1.ModelContractRate.SINGLE,
        description: `Specifies if the users wants to see the rates when only using a single tariff throughout the day.
Or when the user wants to see the night and day tariff. We default the verbruiksprofiel to E1A for single rate and E2A for double rate.`,
    }),
    tslib_1.__metadata("design:type", String)
], GetModelContractQueryV2.prototype, "rate", void 0);
exports.default = GetModelContractQueryV2;
